"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CategoryNavigation;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function CategoryNavigation(props) {
  var categories = props.categories;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Menu, {
    className: "fc-menu-category-navigation",
    secondary: true,
    attached: "top",
    items: createCategoryMenuItems(categories)
  });
}

function createCategoryMenuItems(categories) {
  return categories.map(function (_ref) {
    var name = _ref.name;
    return {
      key: name,
      name: name,
      href: "#".concat(name),
      content: /*#__PURE__*/_react["default"].createElement("h3", null, name)
    };
  });
}